import type { Attachment, ID } from '@octopus-do/octopus-project-core'
import type React from 'react'

import { DraggableNode } from '../../../DraggableNode'
import { AttachmentContent } from '../AttachmentContent'

interface Props {
  attachment: Attachment
  selectedAttaches: ID[]
  disabled: boolean
}

const AttachmentNode: React.FC<Props> = ({
  attachment,
  disabled: disabledEdit,
  selectedAttaches,
}) => {
  const selected = selectedAttaches.includes(attachment.id)
  const disabled = disabledEdit || (selected && attachment.type === 'thread')

  return (
    <DraggableNode
      selected={selected}
      type={attachment.type}
      attachment={attachment}
      key={attachment.id}
      disabled={disabled}
    >
      <AttachmentContent selected={selected} attachment={attachment} />
    </DraggableNode>
  )
}

export default AttachmentNode
